import { useTexts } from "Components/TextContext";
import { Plurals } from "Components/TextContext/textInterfaces";
import { ProductCategory } from "../valuablesConstants";

export const getProductLabel = (
  getText: ReturnType<typeof useTexts>["getText"],
  product: ProductCategory,
  plural?: Plurals,
): string => {
  switch (product) {
    case ProductCategory.NATIONAL_COSTUME:
      return getText("valuablesform.option.product-national_costume", {
        plurals: plural,
      });
    case ProductCategory.FUR_COAT:
      return getText("valuablesform.option.product-fur_coat", {
        plurals: plural,
      });
    case ProductCategory.CAMERA:
      return getText("valuablesform.option.product-camera_equipment", {
        plurals: plural,
      });
    case ProductCategory.HEARING_AID:
      return getText("valuablesform.option.product-hearing_aid", {
        plurals: plural,
      });
    case ProductCategory.COMPUTER_EQUIPMENT:
      return getText("valuablesform.option.product-computer_equipment", {
        plurals: plural,
      });
    case ProductCategory.GOLF_EQUIPEMENT:
      return getText("valuablesform.option.product-golf_equipment", {
        plurals: plural,
      });
    case ProductCategory.FIREARM:
      return getText("valuablesform.option.product-firearm", {
        plurals: plural,
      });
    case ProductCategory.BIKE:
      return getText("valuablesform.option.product-bicycle", {
        plurals: plural,
      });
    case ProductCategory.EL_BIKE:
      return getText("valuablesform.option.product-electric_bicycle", {
        plurals: plural,
      });
    case ProductCategory.OTHER:
      return getText("valuablesform.option.product-other", { plurals: plural });
    default:
      throw new Error(`Missing text handling for [product=${product}]`);
  }
};
